import { useContext } from "react";
import { ThemeContext } from "../App";
import { MdDarkMode, MdLightMode } from "react-icons/md";

const Toggler = () => {
  const { theme, toggleTheme } = useContext(ThemeContext);
  return (
    <div className="toggle-theme" onClick={toggleTheme}>
      {theme === "light" ? (
        <MdDarkMode size="32" color="#ff7f50" />
      ) : (
        <MdLightMode size="34" color="#ff7f50" />
      )}
    </div>
  );
};

export default Toggler;
